import { render, staticRenderFns } from "./AddPieTDWidgetForParentOrg.vue?vue&type=template&id=f6ff71c8"
import script from "./AddPieTDWidgetForParentOrg.vue?vue&type=script&lang=js"
export * from "./AddPieTDWidgetForParentOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports